import LockClosedIcon from '@heroicons/react/outline/esm/LockClosedIcon.js'
import { clsx } from 'clsx'

import { Space } from '@tribeplatform/gql-client/types'
import { useRouter } from '@tribeplatform/react-sdk'

import { StaticField } from '../../Views/types.js'
import { getTitleSizeClass } from '../utils/index.js'

interface Props {
  field: StaticField
  space: Space
  highlighted: boolean
  stretchX: string
  preview: boolean
}
export const SpaceTitle = ({
  field,
  space,
  highlighted,
  stretchX,
  preview,
}: Props) => {
  const { Link } = useRouter()
  const { default: defaultTitle } = field
  const title = space?.name || (preview ? defaultTitle : '')
  const titleSize = field.settings?.titleSize
  const titleSizeClass = getTitleSizeClass(titleSize)
  const isPrivate = space?.private

  return (
    <Link
      href={space?.relativeUrl ?? ''}
      variant="inherit"
      className={clsx(
        stretchX,
        'break-words min-w-0 transition-none',
        highlighted &&
          'ring-2 rounded-sm ring-offset-surface ring-focused block',
      )}
      onClick={e => e.stopPropagation()}
    >
      <h2 className={clsx('text-content line-clamp-3', titleSizeClass)}>
        {isPrivate && (
          <div className="inline-flex self-center">
            <LockClosedIcon
              className="relative"
              style={{ width: '1em', height: '1em', top: '0.125em' }}
            />
            &nbsp;
          </div>
        )}
        {title}
      </h2>
    </Link>
  )
}
